"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HighlightedSegment = void 0;
const react_1 = __importStar(require("react"));
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const react_highlight_words_1 = __importDefault(require("react-highlight-words"));
const formatTime = (seconds) => {
    const format = (val) => `0${Math.floor(val)}`.slice(-2);
    const hours = seconds / 3600;
    const minutes = (seconds % 3600) / 60;
    const secs = seconds % 60;
    return [...(hours >= 1 ? [hours] : []), minutes, secs].map(format).join(':');
};
const useStyles = (0, makeStyles_1.default)({
    chip: {
        fontSize: '12px',
        marginRight: '4px',
        cursor: 'pointer',
        color: '#CB0000',
        fontWeight: 500
    },
    text: {
        fontSize: '12px',
        fontWeight: 500
    },
    subtitleBackground: {
        borderRadius: '4px',
        border: ({ isActive, searchWords }) => {
            var _a, _b;
            return isActive && !((_b = (_a = searchWords[0]) === null || _a === void 0 ? void 0 : _a.trim()) === null || _b === void 0 ? void 0 : _b.length)
                ? 'solid yellow 1px'
                : 'none';
        },
        background: ({ isActive, searchWords }) => {
            var _a, _b;
            return isActive && !((_b = (_a = searchWords[0]) === null || _a === void 0 ? void 0 : _a.trim()) === null || _b === void 0 ? void 0 : _b.length)
                ? '#FAFAFA'
                : 'transparent';
        }
    }
});
exports.HighlightedSegment = (0, react_1.memo)(({ subtitle, isActive, onClick, searchWords = [] }) => {
    const classes = useStyles({ isActive, searchWords });
    return (react_1.default.createElement(Box_1.default, { display: "flex", alignItems: "center", justifyContent: "start", px: 1, style: { cursor: 'pointer' }, className: classes.subtitleBackground, onClick: onClick },
        react_1.default.createElement(Box_1.default, { display: "flex", justifyContent: "space-between", style: { width: '100%' } },
            react_1.default.createElement(Box_1.default, { ml: 1, p: 1 },
                react_1.default.createElement(react_highlight_words_1.default, { highlightStyle: {
                        backgroundColor: '#FFF2C7'
                    }, searchWords: searchWords, textToHighlight: subtitle === null || subtitle === void 0 ? void 0 : subtitle.text, className: classes.text }))),
        react_1.default.createElement(Typography_1.default, { className: classes.chip }, formatTime(subtitle.start))));
});
//# sourceMappingURL=highlighted-segment.js.map